<form [formGroup]="parent">
  <div class="d-flex row">
    <div class="col-4">
      <div class="form-group has-float-label mb-4">
        <label class="form-label" for="Caccount"
          >Program<span class="madatory-field">*</span></label
        >
        <input
          pInputText
          jniAutoCompleteBlocker
          name="pName"
          type="text"
          class="form-control"
          formControlName="name"
          id="pName"
          [readonly]="isReadOnly"
          (change)="onValueChange()"
          (blur)="logValidationErrors()" />
        <span class="error-msg" *ngIf="formErrors['name']">
          {{ formErrors["name"] }}
        </span>
      </div>
    </div>
    <div class="col-4">
      <div class="form-group has-float-label mb-4">
        <label class="form-label" for="brandingConsultantD365"
          >BC<span class="madatory-field">*</span></label
        >
        <p-select
          formControlName="brandingConsultantD365"
          (onChange)="selectionChange()"
          [(ngModel)]="bcVal"
          (blur)="logValidationErrors()"
          [options]="bcList"
          optionLabel="displayValue"
          optionValue="personnelNumber"
          [filter]="true"
          [disabled]="isReadOnly"
          [readonly]="isReadOnly"
          [showClear]="!isReadOnly">
        </p-select>
        <span class="error-msg" *ngIf="formErrors['brandingConsultantD365']">
          {{ formErrors["brandingConsultantD365"] }}
        </span>
      </div>
    </div>
    <div class="col-4">
      <div class="form-group has-float-label mb-4">
        <label class="form-label" for="Caccount"
          >D365 Pgm Dimension
          <span>(Admin only)</span>
        </label>
        <p-select
          formControlName="dimensionD365"
          (onChange)="selectionChange()"
          [disabled]="isAdminCheck && !isEditDimension ? true : false"
          [readonly]="isAdminCheck && !isEditDimension ? true : false"
          [(ngModel)]="dimensionD365Val"
          [options]="pgmDimensionList"
          optionLabel="descriptionD365"
          optionValue="displayValueD365"
          [filter]="true"
          [showClear]="!isEditDimension">
        </p-select>
      </div>
    </div>
  </div>
  <div class="d-flex row">
    <div class="col-4 mb-4">
      <div class="form-group switcher">
        <label class="form-label d-block mb-2" for="resale"
          >OnBoard with Ecommerce Department ?</label
        >
        <div class="form-check form-switch d-flex align-items-center m-0">
          <p-toggleswitch
            id="flexSwitchCheckDefault"
            name="flexSwitchCheckDefault"
            formControlName="ecomOnboard"
            [readonly]="isReadOnly"
            [disabled]="isReadOnly"
            (onChange)="onValueChange()" />
          <label class="form-check-label mx-2" for="flexSwitchCheckDefault">
            {{ this.parent.get(["ecomOnboard"])?.value ? "Yes" : "No" }}
          </label>
        </div>
      </div>
    </div>
    <div class="col-8">
      <div class="row" *ngIf="isAdminCheck">
        <div class="col-4 mb-4">
          <div class="form-group switcher">
            <label class="form-label d-block mb-2" for="resale">Approve</label>
            <div class="form-check form-switch d-flex align-items-center m-0">
              <p-toggleswitch
                id="flexSwitchCheckDefault"
                name="flexSwitchCheckDefault"
                formControlName="isApproved"
                [readonly]="isReadOnly || mode === 'Add' ? true : false"
                [disabled]="isReadOnly"
                (onChange)="onApprove()" />
              <label class="form-check-label mx-2" for="flexSwitchCheckDefault">
                {{ this.parent.get(["isApproved"])?.value ? "Yes" : "No" }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-4 mb-4">
          <div class="form-group switcher">
            <label class="form-label d-block mb-2" for="resale"
              >Client Lock</label
            >
            <div class="form-check form-switch d-flex align-items-center m-0">
              <p-toggleswitch
                id="flexSwitchCheckDefault"
                name="flexSwitchCheckDefault"
                formControlName="isClientLock"
                [readonly]="isReadOnly || mode === 'Add' ? true : false"
                [disabled]="isReadOnly"
                (onChange)="onValueChange()" />
              <label class="form-check-label mx-2" for="flexSwitchCheckDefault">
                {{ this.parent.get(["isClientLock"])?.value ? "Yes" : "No" }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-4 mb-4">
          <div class="form-group switcher">
            <label class="form-label d-block mb-2" for="resale">Disable</label>
            <div class="form-check form-switch d-flex align-items-center m-0">
              <p-toggleswitch
                id="flexSwitchCheckDefault"
                name="flexSwitchCheckDefault"
                formControlName="isDisabled"
                [readonly]="isReadOnly || mode === 'Add' ? true : false"
                [disabled]="isReadOnly"
                (onChange)="onValueChange()" />
              <label class="form-check-label mx-2" for="flexSwitchCheckDefault">
                {{ this.parent.get(["isDisabled"])?.value ? "Yes" : "No" }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex row">
    <div class="col-3 mt-2 program-border">
      <div class="col mt-3">
        <div class="mb-4">
          <div class="form-group switcher">
            <label class="form-label d-block mb-2" for="resale"
              >Client Owned Inventory</label
            >
            <div class="form-check form-switch d-flex align-items-center m-0">
              <p-toggleswitch
                id="flexSwitchCheckDefault"
                name="flexSwitchCheckDefault"
                formControlName="clienttOwnInv"
                [readonly]="isReadOnly"
                [disabled]="isReadOnly"
                (onChange)="onValueChange()" />
              <label class="form-check-label mx-2" for="flexSwitchCheckDefault">
                {{ this.parent.get(["clienttOwnInv"])?.value ? "Yes" : "No" }}
              </label>
            </div>
          </div>
        </div>
        <div class="mb-4">
          <div class="form-group switcher">
            <label class="form-label d-block mb-2" for="resale"
              >Nadel Owned Inventory</label
            >
            <div class="form-check form-switch d-flex align-items-center m-0">
              <p-toggleswitch
                id="flexSwitchCheckDefault"
                name="flexSwitchCheckDefault"
                formControlName="nadelOwnInv"
                [readonly]="isReadOnly"
                [disabled]="isReadOnly"
                (onChange)="onValueChange()" />
              <label class="form-check-label mx-2" for="flexSwitchCheckDefault">
                {{ this.parent.get(["nadelOwnInv"])?.value ? "Yes" : "No" }}
              </label>
            </div>
          </div>
        </div>
        <div class="col mb-4">
          <div class="form-group switcher">
            <label class="form-label d-block mb-2" for="resale"
              >INTL Program</label
            >
            <div class="form-check form-switch d-flex align-items-center m-0">
              <p-toggleswitch
                id="flexSwitchCheckDefault"
                name="flexSwitchCheckDefault"
                formControlName="intl"
                [readonly]="isReadOnly"
                [disabled]="isReadOnly"
                (onChange)="onValueChange()" />
              <label class="form-check-label mx-2" for="flexSwitchCheckDefault">
                {{ this.parent.get(["intl"])?.value ? "Yes" : "No" }}
              </label>
            </div>
          </div>
        </div>
        <div class="col mb-4">
          <div class="form-group switcher">
            <label class="form-label d-block mb-2" for="resale"
              >Microsite</label
            >
            <div class="form-check form-switch d-flex align-items-center m-0">
              <p-toggleswitch
                id="flexSwitchCheckDefault"
                name="flexSwitchCheckDefault"
                formControlName="micro"
                [readonly]="isReadOnly"
                [disabled]="isReadOnly"
                (onChange)="onValueChange()" />
              <label class="form-check-label mx-2" for="flexSwitchCheckDefault">
                {{ this.parent.get(["micro"])?.value ? "Yes" : "No" }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-9 mt-2 program-border">
      <div class="row">
        <div class="col-4 mb-3 mt-3">
          <div class="form-group switcher">
            <label class="form-label d-block" for="resale">Website</label>
            <div class="form-check form-switch d-flex align-items-center m-0">
              <p-toggleswitch
                id="flexSwitchCheckDefault"
                name="flexSwitchCheckDefault"
                formControlName="usesWebsite"
                [readonly]="isReadOnly"
                [disabled]="isReadOnly"
                (onChange)="onValueChange()" />
              <label class="form-check-label mx-2" for="flexSwitchCheckDefault">
                {{ this.parent.get(["usesWebsite"])?.value ? "Yes" : "No" }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-4 mb-4 mt-3">
          <div class="form-group has-float-label col-11">
            <label class="form-label" for="webPlatform">Platform</label>
            <p-select
              formControlName="webPlatId"
              (onChange)="selectionChange()"
              [(ngModel)]="webPlatform"
              [options]="platformList"
              optionLabel="name"
              optionValue="value"
              [filter]="true"
              [showClear]="!isReadOnly"
              [readonly]="isReadOnly"
              [disabled]="isReadOnly">
            </p-select>
          </div>
        </div>
        <div class="col-4 mb-4 mt-3">
          <div class="form-group has-float-label">
            <label class="form-label" for="Caccount">Website URL </label>
            <input
              pInputText
              jniAutoCompleteBlocker
              name="webURL"
              type="text"
              class="form-control"
              formControlName="website1"
              id="webURL"
              [readonly]="isReadOnly"
              (change)="onValueChange()" />
          </div>
        </div>
        <div class="col-4 mb-4">
          <div class="form-group switcher">
            <label class="form-label d-block" for="resale"
              >In Store CC Payment</label
            >
            <div class="form-check form-switch d-flex align-items-center m-0">
              <p-toggleswitch
                id="flexSwitchCheckDefault"
                name="flexSwitchCheckDefault"
                formControlName="inStoreCC"
                [readonly]="isReadOnly"
                [disabled]="isReadOnly"
                (onChange)="onValueChange()" />
              <label class="form-check-label mx-2" for="flexSwitchCheckDefault">
                {{ this.parent.get(["inStoreCC"])?.value ? "Yes" : "No" }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-8 mb-4">
          <div class="form-group has-float-label col-5">
            <label class="form-label" for="facilitator">Facilitator</label>
            <p-select
              formControlName="inStoreCCProvider"
              (onChange)="selectionChange()"
              [(ngModel)]="facilitator"
              [options]="facilitatorList"
              optionLabel="name"
              optionValue="value"
              [filter]="true"
              [showClear]="!isReadOnly"
              [readonly]="isReadOnly"
              [disabled]="isReadOnly">
            </p-select>
          </div>
        </div>
        <div class="col-4 mb-4">
          <div class="form-group switcher">
            <label class="form-label d-block" for="resale">3PL Warehouse</label>
            <div class="form-check form-switch d-flex align-items-center m-0">
              <p-toggleswitch
                id="flexSwitchCheckDefault"
                name="flexSwitchCheckDefault"
                formControlName="uses3PL"
                [readonly]="isReadOnly"
                [disabled]="isReadOnly"
                (onChange)="onValueChange()" />
              <label class="form-check-label mx-2" for="flexSwitchCheckDefault">
                {{ this.parent.get(["uses3PL"])?.value ? "Yes" : "No" }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-8 mb-4">
          <div class="form-group has-float-label col-5">
            <label class="form-label" for="threePl1">3-PL</label>
            <p-select
              formControlName="threePL1Id"
              (onChange)="selectionChange()"
              [(ngModel)]="threePl1"
              [options]="threePLList"
              optionLabel="name"
              optionValue="value"
              [filter]="true"
              [showClear]="!isReadOnly"
              [readonly]="isReadOnly"
              [disabled]="isReadOnly">
            </p-select>
          </div>
        </div>
        <div class="col-4 mb-4">
          <div class="form-group switcher">
            <label class="form-label d-block" for="resale"
              >Avalara Tax Integration</label
            >
            <div class="form-check form-switch d-flex align-items-center m-0">
              <p-toggleswitch
                id="flexSwitchCheckDefault"
                name="flexSwitchCheckDefault"
                formControlName="avaTaxIntegration"
                [readonly]="isReadOnly"
                [disabled]="isReadOnly"
                (onChange)="onValueChange()" />
              <label class="form-check-label mx-2" for="flexSwitchCheckDefault">
                {{
                  this.parent.get(["avaTaxIntegration"])?.value ? "Yes" : "No"
                }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-3 description-margin">
      <div class="form-group has-float-label">
        <label class="form-label" for="descpt">Description</label>
        <textarea
          jniAutoCompleteBlocker
          formControlName="description"
          class="form-control"
          pInputText
          style="height: 100px"
          (change)="onValueChange()"
          [readonly]="isReadOnly"></textarea>
      </div>
    </div>
  </div>
</form>
